import company from "@content/legal/company.json";

/**
 * Replace {{placeholder}} tokens in a string with values from company.json.
 * Unknown placeholders are left untouched so mistakes are obvious.
 */
export const fillTokens = (input) => {
    if (input == null) return input;
    if (Array.isArray(input)) return input.map(fillTokens);
    if (typeof input === "object") {
        const out = {};
        for (const k of Object.keys(input)) out[k] = fillTokens(input[k]);
        return out;
    }
    if (typeof input !== "string") return input;
    return input.replace(/\{\{(\w+)\}\}/g, (m, key) =>
        Object.prototype.hasOwnProperty.call(company, key) ? company[key] : m
    );
};

export const formatDate = (iso) => {
    if (!iso) return "";
    try {
        return new Date(iso).toLocaleDateString("en-IN", {
            day: "numeric",
            month: "long",
            year: "numeric",
        });
    } catch {
        return iso;
    }
};
